module.exports = __webpack_public_path__ + "static/img/596_phase_function_Paper_Points.f7e4265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/596_phase_function_Paper_Points.png
// module id = KDjv
// module chunks = 0